import * as React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {businessIncentivesLinks} from '~/modules/BusinessIncentives/links';
import {BusinessIncentivesView} from '~/modules/BusinessIncentives/views/BusinessIncentivesView';
import {BusinessIncentiveView} from '~/modules/BusinessIncentives/views/BusinessIncentiveView';

export * from './links';

export const BusinessIncentivesRoute = () => (
    <Breadcrumb
        breadcrumb={{
            to: businessIncentivesLinks.businessIncentives(),
            title: 'Expenses',
        }}
    >
        <Routes>
            <Route index element={<BusinessIncentivesView/>}/>
            <Route path=":incentiveId" element={<BusinessIncentiveView/>}/>
            <Route path="*" element={<Navigate to={businessIncentivesLinks.businessIncentives()} replace/>}/>
        </Routes>
    </Breadcrumb>
);
